import { render, staticRenderFns } from "./TableCategoryLab.vue?vue&type=template&id=6e1daf4a"
import script from "./TableCategoryLab.vue?vue&type=script&lang=js"
export * from "./TableCategoryLab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports